/* Formaty dla MAT_DATE_FORMATS i NGX_MAT_DATE_FORMATS. Plik jest liściem bez importów, bo sięga po niego
   i AppModule, i komponenty z leniwie ładowanych modułów - trzymanie ich w app.module byłoby dla tych
   drugich cyklem. */

/** Domyślny format datetime-pickera. */
export const CUSTOM_MOMENT_DATETIME_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY HH:mm:ss'
  },
  display: {
    dateInput: 'DD-MM-YYYY HH:mm:ss',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'DD-MM-YYYY HH:mm:ss',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

/** Domyślny format mat-datepickera; nadaje się też pod NGX_MAT_DATE_FORMATS dla pickerów z [hideTime]. */
export const CUSTOM_MOMENT_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY'
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'DD-MM-YYYY',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

/** Dla pól ustawianych z dokładnością do minuty. Ten sam format służy do wyświetlania i do parsowania
    tekstu wpisanego z ręki, więc sekundy trzeba ściąć tutaj, a nie na gotowym napisie. */
export const CUSTOM_MOMENT_DATETIME_FORMATS_NO_SECONDS = {
  parse: {
    dateInput: 'DD-MM-YYYY HH:mm'
  },
  display: {
    dateInput: 'DD-MM-YYYY HH:mm',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'DD-MM-YYYY HH:mm',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};
